export class ServiceResponse<T> {
    public status: boolean;
    public data: T = null;
    public message: string = null;

    constructor(pStatus: boolean, pVal?: T | string) {
        this.status = pStatus;
        if (this.status) {
            this.data = <T>pVal;
        } else {
            this.message = <string>pVal;
        }
    }
}